// Levenshtein distance between 2 strings calculation function
const getLevenshteinDistance = (a, b) => {
  if (a.length === 0) {
    return b.length
  }
  if (b.length === 0) {
    return a.length
  }
  let tmp
  let i
  let j
  let prev
  let val
  // swap to save some memory O(min(a,b)) instead of O(a)
  if (a.length > b.length) {
    tmp = a
    a = b
    b = tmp
  }

  const row = Array(a.length + 1)
  // init the row
  for (i = 0; i <= a.length; i++) {
    row[i] = i
  }

  // fill in the rest
  for (i = 1; i <= b.length; i++) {
    prev = i
    for (j = 1; j <= a.length; j++) {
      if (b[i - 1] === a[j - 1]) {
        val = row[j - 1] // match
      } else {
        val = Math.min(
          row[j - 1] + 1, // substitution
          Math.min(
            prev + 1, // insertion
            row[j] + 1,
          ),
        ) // deletion
      }
      row[j - 1] = prev
      prev = val
    }
    row[a.length] = prev
  }
  return row[a.length]
}

/**
 * Calculate the match score by using difference between the original string length and Levenshtein Distance
 */
const getFuzzyMatchScore = (str1 = '', str2 = '') => {
  const lDistance = getLevenshteinDistance(str1, str2)
  const difference = lDistance / str1.length
  return Math.max(1 - difference, 0)
}

export default getFuzzyMatchScore
